module.exports = __webpack_public_path__ + "static/heart_smart_spice-cef1ae97baa2430faeaebab0b8036e98.jpg";